// Порт из market (buyer-only: PWA — ресторанный канал).
import { isValidLegalName, LEGAL_NAME_FORMAT_MESSAGE } from './legalName'
import { isRuPhoneComplete } from './phoneInput'

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const INN_RE = /^\d{10}(\d{2})?$/

export type RegisterFormField =
  | 'firstName'
  | 'lastName'
  | 'email'
  | 'password'
  | 'phone'
  | 'inn'
  | 'legalName'
  | 'tradeName'
  | 'consent'
  | 'consentOffer'

export type RegisterFormFieldErrors = Partial<Record<RegisterFormField, string>>

export type RegisterFormValues = {
  firstName: string
  lastName: string
  email: string
  password: string
  phone: string
  inn: string
  legalName: string
  tradeName: string
  consent: boolean
  consentOffer: boolean
}

export const hasRegisterFormErrors = (errors: RegisterFormFieldErrors): boolean =>
  Object.keys(errors).length > 0

export const validateRegisterForm = (values: RegisterFormValues): RegisterFormFieldErrors => {
  const errors: RegisterFormFieldErrors = {}

  if (!values.firstName.trim()) {
    errors.firstName = 'Введите имя'
  }
  if (!values.lastName.trim()) {
    errors.lastName = 'Введите фамилию'
  }
  if (!values.email.trim()) {
    errors.email = 'Введите email'
  } else if (!EMAIL_RE.test(values.email.trim())) {
    errors.email = 'Введите корректный email, например ivan@company.ru'
  }
  if (!values.password) {
    errors.password = 'Введите пароль'
  } else if (values.password.length < 8) {
    errors.password = 'Пароль должен содержать не менее 8 символов'
  }
  if (!isRuPhoneComplete(values.phone)) {
    errors.phone = 'Введите телефон полностью в формате +7 900 123 45 67'
  }
  if (!values.inn.trim()) {
    errors.inn = 'Введите ИНН'
  } else if (!INN_RE.test(values.inn.trim())) {
    errors.inn = 'ИНН должен содержать 10 или 12 цифр'
  }
  if (!values.legalName.trim()) {
    errors.legalName = 'Введите юридическое название'
  } else if (!isValidLegalName(values.legalName)) {
    errors.legalName = LEGAL_NAME_FORMAT_MESSAGE
  }
  if (!values.tradeName.trim()) {
    errors.tradeName = 'Введите торговое название'
  }
  if (!values.consent) {
    errors.consent = 'Нужно согласие на обработку персональных данных'
  }
  if (!values.consentOffer) {
    errors.consentOffer = 'Нужно принять публичную оферту'
  }

  return errors
}
